/**
 Adzuki.AjaxPagination
 when we want pagination to work via ajax in a modal
 */

(function AjaxPagination($, Adzuki)
{
	"use strict";

	var AjaxPagination = {};

	$(".modal").on("click", ".pagination .ajax", function ajaxPagination(e) {
		var $self       = $(this),
		    $modal      = $self.closest('.modal'),
		    $modal_body = $modal.find('.modal-body'),
		    $header     = $modal.find('.modal-title'),
		    url         = $self.attr('href');

		e.preventDefault();

		$header.append('<span id="pagination-loading"> <i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin"></i></span>');

		Adzuki.Ajax.get(url)
		.then(function showDetails(data) {
			$modal_body.html(data);
			$('#pagination-loading').remove();
		});
	});

	// when we loaded content on the page via ajax that we want to paginate without a full page refresh. this will use the pagination link to replace the ajax content
	$(".ajax-pagination").on("click", ".pagination .ajax", function ajaxPagination(e) {
		var $self       = $(this),
			$container  = $self.closest('.ajax-pagination'),
			loading_ani = $container.data('loading-animation'),
			scroll_top  = $container.data('scroll-top'),
			no_history  = $container.data('no-browser-history'),
			url         = $self.attr('href');

		e.preventDefault();

		if (no_history === undefined) {
			AjaxPagination.adjustBrowserHistory(url);
		}

		if (loading_ani !== undefined) {
			AjaxPagination.defaultLoading($container);
		}

		Adzuki.Ajax.get(url)
		.then(function showDetails(data) {
			$container.html(data);

			if (loading_ani !== undefined) {
				AjaxPagination.defaultLoadingEnd($container);
			}

			if (scroll_top === undefined || scroll_top === true) {
				AjaxPagination.scrollUp();
			}

			// This can be used by client code to trigger a callback after ajax content loaded
			$container.trigger('ajax-pagination.loaded');
		});
	});

	/**
	 * modify the browser history for when user hits back or forward in browser
	 *
	 * @param  string url   the ajax url, which should have a page_num:X
	 */
	AjaxPagination.adjustBrowserHistory = function adjustBrowserHistory(url) {
		var split_new    = url.split("page_num:"),
			history_url  = window.location.href,
			regex        = /(#page_num:)([0-9]*)/;

		if (split_new.length > 1) {
			// clear any prior #page_num:X
			history_url  = history_url.replace(regex, '');

			// set the new page_num
			history_url += '#page_num:' + split_new[1];
		}

		history.pushState({}, "", history_url);
	};

	AjaxPagination.defaultLoading = function defaultLoading($element) {
		var opacity = '0.3';

		// this means the opacity is already set on the element (probably via an earlier JS call) and we don't need to apply again
		if ($element.css('opacity') === opacity) {
			return;
		}

		$element.css('opacity', opacity);
		$element.css('pointer-events', 'none');

		// $element.prepend('<span class="pagination-loading"> <i class="fa fa-spinner fa-spin fa-4x"></i></span>');

		// trying .before() instead of .prepend(), because opacity is getting applied to the spinner when using .prepend()
		$element.before('<span class="pagination-loading"> <i class="fa fa-spinner fa-spin fa-4x"></i></span>');
	};

	AjaxPagination.defaultLoadingEnd = function defaultLoadingEnd($element) {
		$element.css('opacity', '1');
		$element.css('pointer-events', 'auto');

		// need this line when using .before() within defaultLoading()
		$(".pagination-loading").remove();
	};

	AjaxPagination.getPageNumberHash = function getPageNumberHash() {
		var hash   = $(location).prop('hash'),
		    split  = hash.split('#'),
		    output = '';

		$.each(split, function loopHash( index, value ) {
			if (value.indexOf('page_num:') >= 0) {
				output = value;
				return false;
			}
		});

		return output;
	};

	AjaxPagination.scrollUp = function scrollUp() {
		var $scroll_to  = $('body'),
		    scroll_over = $(".ajax-pagination").data('scroll-to-element-id'); // potential override for which element to scroll to

		// if data-scroll-to-element-id is present and an element with that id actually exists on the page
		if ( (scroll_over !== undefined) && ($('#' + scroll_over)) ) {
			$scroll_to = $('#' + scroll_over);
		}

		$('html, body').animate({
			scrollTop: ($scroll_to.offset().top)
		}, 600);
	};

	Adzuki.AjaxPagination = AjaxPagination;

}(jQuery, window.Adzuki || {}));
